export default __webpack_public_path__ + "static/media/LOGIN.6ab29ca9.jpg";